import { MenuList as MuiMenuList } from '@mui/material';
import type { MenuListProps as MuiMenuListProps } from '@mui/material/MenuList';

export type MenuListProps = MuiMenuListProps;

export const MenuList = ({ ...rest }: MenuListProps): JSX.Element => <MuiMenuList {...rest} />;
